import { useEffect } from "react";

export const useScrollPageToTop = (behavior: ScrollBehavior = "auto") => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior
    });
  }, []);
};
